import { safeAuthRedirect } from './authRedirect';

/** Where a trip timeline falls back to when it has no record of the page it was opened from. */
export const TRIPS_LIST_PATH = '/trips';

/**
 * Navigation state to attach when linking into a trip timeline, so the
 * timeline's back link can return to the page the link was clicked on.
 */
export function tripOriginState(location) {
  if (!location) return undefined;
  const from = `${location.pathname || ''}${location.search || ''}`;
  return from ? { from } : undefined;
}

function labelFor(to) {
  const path = to.split('?')[0].replace(/\/+$/, '') || '/';
  switch (path) {
    case '/': return 'Back to dashboard';
    case '/trips': return 'Back to trips';
    case '/executives': return 'Back to executives';
    case '/todos': return 'Back to to-dos';
    case '/unfiled': return 'Back to unfiled items';
    default: return 'Back';
  }
}

/**
 * Resolve the trip timeline's back link from the navigation state left by
 * tripOriginState. Without that state — a deep link, a fresh tab, or a reload
 * on the timeline itself — we send the user to the trips list, which is always
 * a valid destination. The label describes wherever the link actually goes.
 */
export function resolveTripBackTarget(state) {
  const from = state && typeof state.from === 'string' ? state.from : '';
  // safeAuthRedirect keeps us on a local path; it answers '/' for anything odd.
  const to = from ? safeAuthRedirect(from) : TRIPS_LIST_PATH;
  return { to, label: labelFor(to) };
}
